/**
* 开户判断
* 说明：整合了基础账户、卡牛信用卡还款账户、非标存管账户
*/
import '@common/polyfill/src/Object.assign'
import domain from '@common/domain'
import ajax from '@finance/ajax'
import CustodyAccountAuth from '@finance/custody-account'
import { accountAcc } from './account_acc'
import { accountTypes } from '../dict'

export const openAccount = (options) => {
  const _options = Object.assign({
    accountType: accountTypes.custody,
    origin: '',
    forwardUrl: window.location.href,
    currentView: false, // 是否在当前窗口打开开户url
    isShowAccountCustodyDialog: true, // 存管账户是否先弹窗提示
    locationJumpType: 'href', // 开户链接的方式，支持'replace, href'两种方式
    success: () => { }, // 成功回调
    error: () => { }, // 失败回调
    cancel: () => { } // 取消登录回调
  }, options)
  switch (_options.accountType) {
    case accountTypes.acc:
      accountAcc(_options)
      break
    case accountTypes.custody:
      (new CustodyAccountAuth()).pass({
        showTip: _options.isShowAccountCustodyDialog,
        origin: _options.origin,
        forwardUrl: _options.forwardUrl,
        jumpType: _options.locationJumpType,
        newView: _options.currentView,
      })
      .then(() => {
        const data = {}
        if (_options.isNeedUserData) {
          return ajax.request({
            url: `${domain.api}/accountws/ws/account/v3/getUserData`
          }).then((result) => {
            data.isOpenAccountAcc = result.data.bizOwners && result.data.bizOwners.indexOf('ACC') !== -1
            data.isOpenAccountCustody = true
            data.userPhone = result.data.registPhone || ''
            data.userName = result.data.userName || ''
            return data
          })
        }
        data.isOpenAccountCustody = true
        return data
      })
      .then((data) => {
        _options.success(data)
      })
      .catch((error) => {
        console.log('Account Error:', error)
      })
      break
    default:
      console.error('Account Error: Wrong accountType config!')
  }
}

export default {
  openAccount
}
